export default "__VITE_ASSET__8m44UNts__"